// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import authorizationRoutes from './authorization';
import billingAndReview from './billingReview';
import createOrderRoutes from './createOrder';
import dashboardRoutes from './dashboard';
import deviceDetailsRoutes from './deviceDetails';
import faqsRoutes from './faqs';
import manageUsersRoutes from './manageUsers';
import orderDetailRoutes from './orderDetail';
import orderRoutes from './order';
import packageInstructionsRoutes from './packageInstructions';
import printReceiptRoutes from './PrintReceipt';
import productSafetyFormRoutes from './ProductSafetyForm';
import warrantyUpdateRoutes from './warrantyUpdate';
import warrantyDetailRoutes from './warrantyDetail';
import managePartnersRoutes from './managePartners';
import manageBulkUsersRoutes from './manageBulkUsers';
import authModelRoutes from './authModelInvite';

export interface IRoute {
    crumbText: string;
    crumbMatchExclusions?: string[];
    component: any;
    exact?: boolean;
    path: string;
    public?: boolean;
}

// Check for correct authentication and access - show access denied page if needed
export const allRoutes: IRoute[] = [
    ...authModelRoutes,
    ...authorizationRoutes,
    ...billingAndReview,
    ...createOrderRoutes,
    ...dashboardRoutes,
    ...deviceDetailsRoutes,
    ...faqsRoutes,
    ...manageUsersRoutes,
    ...orderDetailRoutes,
    ...orderRoutes,
    ...packageInstructionsRoutes,
    ...printReceiptRoutes,
    ...productSafetyFormRoutes,
    ...warrantyDetailRoutes,
    ...warrantyUpdateRoutes,
    ...managePartnersRoutes,
    ...manageBulkUsersRoutes,
];

export default allRoutes;
